import '@cof/plastic-components/fonts.css';

import ReactDOM from 'react-dom/client';

import App from './App';

import '@csstools/normalize.css'; // replace CRA built in normalize with equivalent package

// @ts-expect-error TS2345: Argument of type 'HTMLElement | null' is not assignable to parameter of type 'Container'.
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);
